import TextInput from './TextInput'

export default {
  name: 'text-input',
  configure(config) {
    config.addComponent('text-input', TextInput)
  },
  TextInput
}